export default {
    props: {
        cta: {
            type: String,
            required: false,
            default: '',
        },
        ctaKind: {
            type: String,
            default: null,
        },
        ctaCategory: {
            type: Object,
            default: null,
        },
        ctaLink: {
            type: String,
            default: null,
        }
    },


    computed: {
        generatedCtaLink() {
            if (!this.cta) {
                return null
            }
            if (this.ctaKind === 'link') {
                if (!this.ctaLink) {
                    return null
                }
                return `/${this.ctaLink}`
            }
            if (this.ctaKind === 'category' && this.ctaCategory != null) {
                return route('nl.activities', { 'categories': this.ctaCategory.slug })
            }
        }
    }
}
